import React from 'react'
import { css, useTheme } from '@emotion/react'
import { FooterAbout, SocialLinks } from '../page-builder'
import config from '../../../config.json'

function ThemeFooter({ style, socialIcons = [] }) {
    const theme = useTheme()
    const footerColor = theme.colors.websiteFooter.color
    const footerHoverColor = theme.colors.websiteFooter.hover
    const footerBackground = theme.colors.websiteFooter.backgroundColor
    return (
        <footer
            css={css`
                border-top: 1px solid rgba(0, 0, 0, 0.08);
                background: url('/img/project/footer.png'), ${footerBackground};
                background-size: cover;
                background-position: bottom;
                background-repeat: no-repeat;
                color: ${footerColor};
                .typography,
                .link a {
                    color: ${footerColor};
                }
                .link a {
                    &:hover {
                        color: ${footerHoverColor};
                    }
                }
                ${style}
            `}
        >
            <FooterAbout
                about={config.texts?.footer_about}
                src="/img/project/logo-light.png"
                style="text-align: center; max-width: 40rem; margin: 0 auto; .typography {text-align: center !important;}"
                social={
                    <SocialLinks
                        socials={[
                            ...socialIcons,
                            ...(config?.texts?.social?.value ?? []),
                            { name: 'rss', href: '/feeds' },
                        ]}
                        style="justify-content: center;"
                    />
                }
            />
        </footer>
    )
}

export default ThemeFooter
